import { Public as AnyNetworkIcon } from '@material-ui/icons';
import { ClassAttributes, createElement } from 'react';

import { NetworkTypeKey } from '../../../graphql/generated/graphql_offer';
import AmazonIcon from '../primitive/Icons/Amazon';
import AppleIcon from '../primitive/Icons/Apple';
import FacebookIcon from '../primitive/Icons/Facebook';
import GoogleIcon from '../primitive/Icons/Google';
import InstagramIcon from '../primitive/Icons/Instagram';
import LineIcon from '../primitive/Icons/Line';
import OwnedMediaIcon from '../primitive/Icons/OwnedMedia';
import SnapchatIcon from '../primitive/Icons/Snapchat';
import TwitterIcon from '../primitive/Icons/Twitter';
import YahooIcon from '../primitive/Icons/Yahoo';
import YouTubeIcon from '../primitive/Icons/YouTube';

interface Props {
  network: NetworkTypeKey;
  size?: number;
  className?: string;
}

const CreativeFormatNetworkIcon = ({ network, size, className }: ClassAttributes<HTMLElement> & Props) => {
  switch (network) {
    case 'facebook':
      return <FacebookIcon className={className} size={size} />;
    case 'instagram':
      return <InstagramIcon className={className} size={size} />;
    case 'snapchat':
      return <SnapchatIcon className={className} size={size} />;
    case 'youtube':
      return <YouTubeIcon className={className} size={size} />;
    case 'twitter':
      return <TwitterIcon className={className} size={size} />;
    case 'line':
      return <LineIcon className={className} size={size} />;
    case 'yahoo':
      return <YahooIcon className={className} size={size} />;
    case 'google':
      return <GoogleIcon className={className} size={size} />;
    case 'apple':
      return <AppleIcon className={className} size={size} />;
    case 'amazon':
      return <AmazonIcon className={className} size={size} />;
    case 'owned_media':
      return <OwnedMediaIcon className={className} size={size} />;
    case 'other':
    case 'any_network':
      return <AnyNetworkIcon className={className} />;
    default:
      return <div>{network}</div>;
  }
};

export default CreativeFormatNetworkIcon;
